/**
 * The coaching surface is consumer-facing and speaks of "tuning" a rating. The server's
 * capability schema and eligibility reasons use internal/admin wording ("Rating Adjustment",
 * "Adjust rating", "Already adjusted this year…"), so we soften that wording for display only —
 * the API contract and admin copy are untouched.
 *
 * This is presentation-only and capability-agnostic (no hardcoded keys). The durable fix is a
 * coach-facing label provided by the server; until then this keeps the word "adjustment" out of
 * the member's view. Order matters: replace the longer forms before the stem.
 */
const swap = (input: string, pattern: RegExp, lower: string, upper: string): string =>
  input.replace(pattern, (match) => (match[0] === match[0].toUpperCase() ? upper : lower))

export const toCoachingCopy = (text: string): string =>
  swap(
    swap(swap(text, /adjustments?/gi, 'tuning', 'Tuning'), /adjusted/gi, 'tuned', 'Tuned'),
    /adjust/gi,
    'tune',
    'Tune'
  )
